import { IUserRole } from "../../redux/features/auth/IAuthState";

export const checkHasPermission = (userRole: IUserRole | undefined, permissionKey: string): boolean => {
    if (!permissionKey) return true;
    return !!userRole?.permissionConfigs?.find((config) => config.configKey === permissionKey);
};
